import React from 'react';
import classes from './Banner.module.css';

const Banner = (props) => {
    console.log('props', props)
    let classList = [props.bootstrapClass, classes.Banner];
    if (props.show) {
        classList.push(classes.Visible);
    } else {
        classList.push(classes.Hidden);
    }
   
    return (
        <div 
            className={classList.join(' ')}
        >
            {props.children} &nbsp;
        </div> 

    );
};

export default Banner;